import { render, staticRenderFns } from "./suggest-item.vue?vue&type=template&id=24a0ea5d&scoped=true&"
import script from "./suggest-item.vue?vue&type=script&lang=js&"
export * from "./suggest-item.vue?vue&type=script&lang=js&"
import style0 from "./suggest-item.vue?vue&type=style&index=0&id=24a0ea5d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a0ea5d",
  null
  
)

export default component.exports